import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface AccountState {
  statusChecked: boolean;
  isDeleted: boolean;
}

const initialState: AccountState = {
  statusChecked: false,
  isDeleted: false,
};

export const fetchDeletionStatus = createAsyncThunk<
  { isDeleted: boolean },
  string,
  { rejectValue: void }
>('account/fetchDeletionStatus', async (auth0Id, { signal }) => {
  const url = `${process.env.REACT_APP_API_URL || ''}/api/account/status?auth0Id=${encodeURIComponent(auth0Id)}`;
  const res = await fetch(url, { signal });
  if (!res.ok) return { isDeleted: false };
  const data = await res.json();
  return { isDeleted: data?.isDeleted === true };
});

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    markChecked(state) {
      state.statusChecked = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeletionStatus.fulfilled, (state, action) => {
        state.isDeleted = action.payload.isDeleted;
        state.statusChecked = true;
      })
      .addCase(fetchDeletionStatus.rejected, (state) => {
        state.statusChecked = true;
      });
  },
});

export const { markChecked } = accountSlice.actions;
export default accountSlice.reducer;
